import { css } from '@emotion/react';
import {
  ErrorMessage,
  RadioButtonRow,
  fonts,
  space,
} from 'folio-common-components';
import * as React from 'react';
import { type RootState, useActions, useSelector } from '../../state';
import { addressIsPostOfficeBox } from '../../utils/validators';
import { Address } from '../Address';
import { CompanyContactFormCadaster } from '../CompanyContactFormCadaster';

function selector(state: RootState) {
  return {
    showAddressForm: !state.editor.formOwnerAsAddress,
    info: state.editor.people[state.editor.formOwner],
    coreInfo: state.editor.coreInfo,
  };
}

export const TogglableCompanyAddressForm: React.FC = () => {
  const { info, showAddressForm, coreInfo } = useSelector(selector);
  const { editorActions } = useActions();

  return (
    <>
      <p>Adressen bestemmer hvilken kommune selskapet skatter til.</p>
      <RadioButtonRow
        inputProps={{
          checked: !showAddressForm,
          onChange: () => editorActions.setFormOwnerAsAddress(true),
          name: 'sameCompanyAddress',
        }}
        id="companyAddressHome"
        label={
          info.address && info.postalCode ? (
            <Address address={info.address} postalCode={info.postalCode} />
          ) : (
            'Hjemme hos meg'
          )
        }
        description={
          !showAddressForm && addressIsPostOfficeBox(coreInfo.address) ? (
            <ErrorMessage
              css={css`
                ${fonts.font100book};
                margin: 0;
              `}
            >
              Postboks kan ikke benyttes som forretningsadresse
            </ErrorMessage>
          ) : undefined
        }
      />

      <RadioButtonRow
        inputProps={{
          checked: showAddressForm,
          onChange: () => editorActions.setFormOwnerAsAddress(false),
          name: 'sameCompanyAddress',
        }}
        id="companyAddressOther"
        label="Et annet sted"
      />

      {showAddressForm && (
        <div css={space([16], 'margin-top')}>
          <CompanyContactFormCadaster />
        </div>
      )}
    </>
  );
};
